<template>
    <base-button
        type="a"
        href="https://add.eventable.com/events/5eec898ace5d8c004f1193ed/5eec89a578c036006e58c278"
        target="_blank"
        rel="noopener"
        data-key="5eec898ace5d8c004f1193ed"
        data-event="5eec89a578c036006e58c278"
        data-style="1"
        design="secondary"
        :disabled="true"
    >
        Add to Calendar
    </base-button>
</template>

<script>
    export default {
        name: 'add-to-calendar',

        mounted() {
            !(function(d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (!d.getElementById(id)) {
                    js = d.createElement(s);
                    js.id = id;
                    js.src = 'https://plugins.eventable.com/eventable.js';
                    fjs.parentNode.insertBefore(js, fjs);
                }
            })(document, 'script', 'eventable-script');
        },
    };
</script>
